const EVIDENCE_NAME_PREFIXES = [
  'socialization',
  'exploration',
  'image',
  'conc',
  'exo'
];

export function resolveEvidenceSlot(evidence, fallbackSlot = null, maxSlots = 3) {
  const explicitSlot = Number(
    evidence?.slot ?? evidence?.evidenceSlot ?? evidence?.evidence_slot
  );
  if (
    Number.isInteger(explicitSlot) &&
    explicitSlot >= 1 &&
    explicitSlot <= maxSlots
  ) {
    return explicitSlot;
  }

  const normalizedName = String(evidence?.name ?? evidence ?? '')
    .trim()
    .toLowerCase()
    .replace(/\.[a-z0-9]+$/i, '');

  for (const prefix of EVIDENCE_NAME_PREFIXES) {
    if (!normalizedName.startsWith(prefix)) continue;
    const slot = Number(normalizedName.substring(prefix.length));
    if (Number.isInteger(slot) && slot >= 1 && slot <= maxSlots) {
      return slot;
    }
  }

  return fallbackSlot;
}
